import { ArtDecoNavy } from './ArtDecoNavy';

export default ArtDecoNavy;
